export enum UserInteractionType {
  DEFAULT = 'default',
  TEXT = 'text',
  TEXTBREAK = 'textbreak'
}
